import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  maxWidth?: string;
  height?: string;

  onDrop(acceptedFiles: any): void;
}

const PaiDropzone: React.FC<Props> = ({ maxWidth = '600px', height = '180px', onDrop }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'text/csv': ['.csv'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
      'application/vnd.ms-excel': ['.xls'],
    },
  });

  return (
    <div className={cx(classes.dropzone, isDragActive ? 'dragging' : undefined)} {...getRootProps()} style={{ maxWidth, height }}>
      <input {...getInputProps()} />
      <Stack alignItems={'center'} gap={2}>
        <CloudUploadIcon className={classes.icon} />
        {isDragActive ? (
          <Typography className={classes.dropzoneText}>{t('dropFileHere')}</Typography>
        ) : (
          <Typography className={classes.dropzoneText}>{t('dragFileOrClickHere')}</Typography>
        )}
      </Stack>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  dropzone: {
    width: '100%',
    maxWidth: '600px',
    padding: '16px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: `2px dashed ${theme.palette.greys.medium}`,
    background: '#FFF',
    borderRadius: '12px',
    '&:hover': {
      background: theme.palette.backgrounds.main,
    },
    '&.dragging': {
      border: `2px solid ${theme.palette.greys.medium}`,
      background: `repeating-linear-gradient(
        -45deg,
        #fff,
        #fff 20px,
        ${theme.palette.backgrounds.main} 20px,
        ${theme.palette.backgrounds.main} 40px
      )`,
    },
  },
  dropzoneText: {
    fontSize: theme.typography.pxToRem(15),
  },
  icon: {
    fontSize: theme.typography.pxToRem(56),
    color: theme.palette.greys.medium,
  },
}));

export default PaiDropzone;
